export default __webpack_public_path__ + "static/media/thumbnail-taotrangewb.77ab63a4.png";